
import SVG_ISSUE_HIGH from '../../assets/svg/vam/high.svg'
import SVG_ISSUE_MEDIUM from '../../assets/svg/vam/medium.svg'
import SVG_ISSUE_LOW from '../../assets/svg/vam/low.svg'

export const VAM_REMINDER_STATUS_BY_CODE = {
    'VAMR000': 'Upcoming',
    'VAMR001': 'Due Soon',
    'VAMR002': 'Overdue',
    'VAMR003': 'Snoozed'
}

export const VAM_REMINDER_STATUS_CODE_BY_STATUS = {
    "UPCOMING": 'VAMR000',
    'DUE_SOON': 'VAMR001',
    'OVERDUE': 'VAMR002',
    'SNOOZED': 'VAMR003'
}

export const VAM_REMINDER_STATUS_COLOR_BY_CODE = {
    'VAMR000': 'green',
    'VAMR001': 'orange',
    'VAMR002': 'red',
    'VAMR003': 'grey'
}

export const VAM_ENTRY_STATUS_BY_CODE = {
    'VAME000': 'Open',
    'VAME100': 'Pending',
    'VAME200': 'Completed'
} 

export const VAM_ENTRY_STATUS_CODE_BY_STATUS = {
    'OPEN': 'VAME000',
    'PENDING': 'VAME100',
    'COMPLETED': 'VAME200'
}

export const VAM_ENTRY_STATUS_COLOR_BY_CODE = {
    'VAME000': 'grey',
    'VAME100': 'orange',
    'VAME200': 'green'
}

export const VAM_ENTRY_STATUS_TITLE = {
    [VAM_ENTRY_STATUS_CODE_BY_STATUS.OPEN]: {
      name: "Open",
      colorTag: "#878787",
      bgColor: "#F8F8F8",
      outline: "#D5D5D5",
      status: VAM_ENTRY_STATUS_CODE_BY_STATUS.OPEN,
    },
    [VAM_ENTRY_STATUS_CODE_BY_STATUS.PENDING]: {
      name: "Pending",
      colorTag: "#FA8C16",
      bgColor: "#FFF7E6",
      outline: "#FFD591",
      status: VAM_ENTRY_STATUS_CODE_BY_STATUS.PENDING,
    },
    [VAM_ENTRY_STATUS_CODE_BY_STATUS.COMPLETED]: {
      name: "Completed",
      colorTag: "#42C601",
      bgColor: "#F6FFED",
      outline: "#B7EB8F",
      status: VAM_ENTRY_STATUS_CODE_BY_STATUS.COMPLETED,
    },
  };

export const VAM_LINE_TYPE_BY_CODE = {
    'VAML001': 'Service',
    'VAML002': 'Regulatory'
}

export const VAM_LINE_TYPE_COLOR_BY_CODE = {
    'VAML001': 'green',
    'VAML002': 'purple'
}

export const VAM_DUE_PARAM = {
    'time': 'time',
    'odometer': 'odometer',
    'workingHour': 'workingHour'
}

export const VAM_DUE_PARAM_REFLECT = {
    'time': 'curTime',
    'odometer': 'odometer',
    'workingHour': 'workingHour'
}

export const VAM_DUE_PARAM_DUE_STATUS = {
    'time': {
        UPCOMING: `from now`,
        DUE_SOON: `from now`,
        OVERDUE: `ago`
    },
    'odometer': {
        UPCOMING: `remaining`,
        DUE_SOON: `remaining`,
        OVERDUE: `overdue`
    },
    'workingHour': {
        UPCOMING: `remaining`,
        DUE_SOON: `remaining`,
        OVERDUE: `overdue`
    }
}

export const  MODAL_CU_PROCESS_ACTION = {
    CREATE: 'CREATE',
    EDIT: 'EDIT'
}

export const TIME_UNIT = {
    day: [ 'day', 'day(s)', 24*60*60*1000 ],
    week: [ 'week', 'week(s)', 7*24*60*60*1000 ],
    month: [ 'month', 'month(s)', 30*24*60*60*1000 ],
    year: [ 'year', 'year(s)', 365*24*60*60*1000 ]
}

export const VEHICLE_ISSUE_STATUS = {
    open: 'VAMI000',
    resolved: 'VAMI100',
    closed: 'VAMI200'
  };
  
  export const VEHICLE_ISSUE_STATUS_TITLE = {
    [VEHICLE_ISSUE_STATUS.open]: {
      name: "Open",
      colorTag: "#878787",
      bgColor: "#F8F8F8",
      outline: "#D5D5D5",
      status: VEHICLE_ISSUE_STATUS.open,
    },
    [VEHICLE_ISSUE_STATUS.resolved]: {
      name: "Resolved",
      colorTag: "#42C601",
      bgColor: "#F6FFED",
      outline: "#B7EB8F",
      status: VEHICLE_ISSUE_STATUS.resolved,
    },
    [VEHICLE_ISSUE_STATUS.closed]: {
        name: "Closed",
        colorTag: "#D2BE79",
        bgColor: "#FFFCEE",
        outline: "#E6D393",
        status: VEHICLE_ISSUE_STATUS.closed,
    },
  };

  export const VEHICLE_ISSUE_PRIORITY = {
    low: 'L',
    medium: 'M',
    high: 'H'
  };
  
  export const VEHICLE_ISSUE_PRIORITY_TITLE = {
    [VEHICLE_ISSUE_PRIORITY.low]: {
      name: "Low",
      colorTag: "#42C601",
      bgColor: "#F6FFED",
      outline: "#B7EB8F",
      icon: SVG_ISSUE_LOW,
      status: VEHICLE_ISSUE_PRIORITY.low,
    },
    [VEHICLE_ISSUE_PRIORITY.medium]: {
      name: "Medium",
      colorTag: "#FA8C16",
      bgColor: "#FFF",
      outline: "#FFD9B0",
      icon: SVG_ISSUE_MEDIUM,
      status: VEHICLE_ISSUE_PRIORITY.medium,
    },
    [VEHICLE_ISSUE_PRIORITY.high]: {
        name: "High",
        colorTag: "#FF0000",
        bgColor: "#FFF",
        outline: "#FFBFBD",
        icon: SVG_ISSUE_HIGH,
        status: VEHICLE_ISSUE_PRIORITY.high,
    },
  };

  // export const VEHICLE_ISSUE_TYPE = {
  //   BP: 'Brake Pad',
  //   EO: 'Engine Oil',
  // };
  
  // export const VEHICLE_ISSUE_TYPE_TITLE = {
  //   [VEHICLE_ISSUE_TYPE.BP]: {
  //   //   name: "Brake Pad",
  //     value: VEHICLE_ISSUE_TYPE.BP,
  //   },
  //   [VEHICLE_ISSUE_TYPE.EO]: {
  //   //   name: "Engine Oil",
  //     value: VEHICLE_ISSUE_TYPE.EO,
  //   },
  // };